export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Ldap.json?hash=85b21f679c0dc93eb060920409f36c9c";